import { defineStore } from 'pinia';
import api from '@/services/api';
import {
  supplier_filters,
  supplier_model,
} from '../models/supplier_model';
import { getParamsUrl } from '../supplier_utils';

export const useSupplierStore = defineStore('supplierStore', {
  state: () => ({
    entity: 'proveedor',
    suppliers: [],
    supplier: { ...supplier_model },
    page: 1,
    filters: {},
  }),
  getters: {},
  actions: {
    async findAllProveedoresHTTP(params) {
      const result = await api.get(
        `/${this.entity}?${getParamsUrl({ page: +this.page, Activo: true, ...this.filters, ...params })}`,
      );
      if (result && result.data.length > 0) {
        this.suppliers.push(...result.data);
        this.setPage(this.page + 1);
        return true;
      }
      return false;
    },
    async findProveedorHTTP(codigo) {
      const result = await api.get(`/${this.entity}/${codigo}`);
      if (result && result.data) {
        this.supplier = result.data;
        return true;
      }
      return false;
    },
    async searchSuppliersHTTP(query) {
      const url = `/${this.entity}?Descripcion=${encodeURIComponent(query)}&page=1`;
      const result = await api.get(url);
      if (result && result.data && result.data.length > 0) {
        return [...result.data];
      }
    },
    async saveProveedor() {
      if (this.supplier.Codigo) {
        return await this.updateProveedorHTTP();
      } else {
        return await this.createProveedorHTTP();
      }
    },
    async createProveedorHTTP() {
      return await api.post(`/${this.entity}`, this.supplier);
    },
    async updateProveedorHTTP() {
      return await api.patch(`/${this.entity}/${this.supplier.Codigo}`, this.supplier);
    },
    async deleteProveedorHTTP(supplier) {
      return await api.patch(`/${this.entity}/${supplier.Codigo}`, { ...supplier, Activo: false });
    },
    resetProveedor() {
      this.supplier = { ...supplier_model };
    },
    resetFilters() {
      this.filters = { ...supplier_filters };
    },
    setPage(page) {
      this.page = page;
    },
    async firstProveedores() {
      this.setPage(1);
      this.emptyList();
      await this.findAllProveedoresHTTP();
    },
    emptyList() {
      this.suppliers = [];
    },
  },
});
